import { render, staticRenderFns } from "./BankDeposits.vue?vue&type=template&id=9522850c"
import script from "./BankDeposits.vue?vue&type=script&lang=js"
export * from "./BankDeposits.vue?vue&type=script&lang=js"
import style0 from "./BankDeposits.vue?vue&type=style&index=0&id=9522850c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports